//#region src/text-tracks.ts
var TextTrackEvent = class extends Event {
	constructor(type, track) {
		super(type);
		this.track = track;
	}
};
/** A caption track the embed reports. YouTube renders its cues inside the iframe, so none are exposed here. */
var YouTubeTextTrack = class {
	#mode;
	#onModeChange;
	constructor(label, language, onModeChange) {
		this.id = "";
		this.kind = "subtitles";
		this.cues = null;
		this.#mode = "disabled";
		this.label = label;
		this.language = language;
		this.#onModeChange = onModeChange;
	}
	get mode() {
		return this.#mode;
	}
	set mode(value) {
		if (this.#mode === value) return;
		this.#mode = value;
		this.#onModeChange();
	}
};
/**
* The text tracks of a YouTube embed. Unlike a `<video>` element's list, tracks can be removed, so each source starts
* empty. Events are queued like native ones, and mode changes within a tick report as one `change`.
*/
var YouTubeTextTrackList = class extends EventTarget {
	#tracks = [];
	#changeQueued = false;
	get length() {
		return this.#tracks.length;
	}
	[Symbol.iterator]() {
		return this.#tracks[Symbol.iterator]();
	}
	getTrackByLanguage(language) {
		return this.#tracks.find((track) => track.language === language);
	}
	add(label, language) {
		const track = new YouTubeTextTrack(label, language, () => this.#queueChange());
		Object.defineProperty(this, this.#tracks.length, {
			value: track,
			configurable: true,
			enumerable: true
		});
		this.#tracks.push(track);
		queueMicrotask(() => this.dispatchEvent(new TextTrackEvent("addtrack", track)));
		return track;
	}
	clear() {
		const removed = this.#tracks;
		this.#tracks = [];
		for (const [index, track] of removed.entries()) {
			delete this[index];
			queueMicrotask(() => this.dispatchEvent(new TextTrackEvent("removetrack", track)));
		}
	}
	#queueChange() {
		if (this.#changeQueued) return;
		this.#changeQueued = true;
		queueMicrotask(() => {
			this.#changeQueued = false;
			this.dispatchEvent(new Event("change"));
		});
	}
};
//#endregion
export { YouTubeTextTrack, YouTubeTextTrackList };
